export const getTruncatedString = (string, maxChars = 50) => {
  if (!string) return "";

  if (string.length < maxChars) return string;

  return string.substring(0, maxChars) + "...";
};

export const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay))